import cx from 'classnames';
import { ReactElement, DetailedHTMLProps, ButtonHTMLAttributes } from 'react';

export interface IButtonProps extends Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'children'
> {
  isLoading?: boolean;
  icon: ReactElement;
  variant?: 'default' | 'primary' | 'destructive' | 'text' | 'outlined';
  size?: 'xsmall' | 'small' | 'medium';
}

export const IconButton = ({
  className,
  variant = 'default',
  type = 'button',
  isLoading,
  disabled,
  icon,
  size = 'medium',
  ...restProps
}: IButtonProps) => {
  const getIcon = (icon: ReactElement) => (isLoading ? <i className="fa fa-spinner fa-spin" /> : icon);

  return (
    <button
      {...restProps}
      disabled={isLoading || disabled}
      type={type}
      className={cx('slds-button slds-button--icon rio-icon-button', className, size, {
        'slds-button--brand': variant === 'primary',
        'slds-button--neutral': variant === 'default',
        'slds-button--destructive': variant === 'destructive',
        'rio-button--outlined': variant === 'outlined',
        'rio-button--text': variant === 'text'
      })}
    >
      {getIcon(icon)}
    </button>
  );
};
